import { string } from 'yup';

export const validationSchema = string().trim().customEmail('E-Mail-Adresse ist ungültig.').required('E-Mail-Adresse fehlt.');
